import React, { FunctionComponent } from 'react';
import { useHistory } from 'react-router';
import { ExpertComponent } from '../../../organisms/Experts/ExpertComponent/ExpertComponent';
import { CoreLayout } from '../../../templates/CoreLayout/CoreLayout';

export const Expert: FunctionComponent = () => {
  const history = useHistory();

  return (
    <CoreLayout title="Expert" navigationType="default" fullWidthEnabled>
      <ExpertComponent />
    </CoreLayout>
  );
};

type UrlParamsType = {
  expertId: string;
};
